<template>
  
    <el-container>
      <el-main>
        <img src="../assets/markmind/home.gif"/>
        <h1>Obsidian markmind</h1>
        <p>强大的思维导图、大纲和 PDF 标注工具</p>
      </el-main>
    </el-container>
 
</template>

<script>
export default {
  name: 'IndexPage',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 h1{
  text-align: center;
  border: 0!important;
 }
 img{
  display: block;
  margin:  30px auto;
  max-width: 1200px!important;
  width:100%;
 }
 p{
  text-align: center;
 }
</style>
